import { useRef, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPodcastsByGenre, setSpotifyDemoPodcastsAviableGenre } from '../redux/slices/podcastsSlice';

export const useGenresCache = () => {
  const dispatch = useDispatch();
  const loadedGenres = useRef(new Map());
  const prevCountry = useRef(null);

  const { currentPodcast, activePlatform } = useSelector((state) => state.podcasts);

  useEffect(() => {
    loadedGenres.current = new Map();
    prevCountry.current = null;
  }, [currentPodcast?.collectionId, activePlatform]);

  const loadGenresForCountry = useCallback(
    (genres, country) => {
      if (!loadedGenres.current.has(country)) {
        loadedGenres.current.set(country, new Set());
      }
      const countryGenres = loadedGenres.current.get(country);
      if (prevCountry.current !== country) {
        genres.forEach((genre) => {
          dispatch(setSpotifyDemoPodcastsAviableGenre(genre.name));
          dispatch(fetchPodcastsByGenre({ genre: genre.name, country }));
          countryGenres.add(genre.name);
        });
        prevCountry.current = country;
        return;
      }
      const newGenres = genres.filter((genre) => !countryGenres.has(genre.name));
      newGenres.forEach((genre) => {
        dispatch(fetchPodcastsByGenre({ genre: genre.name, country }));
        dispatch(setSpotifyDemoPodcastsAviableGenre(genre.name));
        countryGenres.add(genre.name);
      });
    },
    [dispatch, activePlatform]
  );

  return loadGenresForCountry;
};
